import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../header';
import Footer from '../footer';
import Sidebar from '../sidebar';
import Megamenu from '../megamenu';
import Mobsidebar from '../mobile-sidebar';
import soundbmain from '../../images/sound-barrier-main.webp';
import soundb2 from '../../images/sound-barrier-2.webp';
import soundb3 from '../../images/sound-barrier-3.webp';
import soundb4 from '../../images/exterior-quilted-curtain-absorber-1.jpg';
import soundb5 from '../../images/temp-1.jpg';
import soundb6 from '../../images/sound-sil-1.jpg';
import SoundRooms from '../../images/additional-resources/ebook-acoustics-demyst.webp';
import NoiseProb from '../../images/additional-resources/Common-Noise-Problems-3D01x.webp';
import CADCSI from '../../images/additional-resources/ebook-cad-revit.webp';
import './sound-barrier.css';
import ScrollToTopButton from '../ScrollButton';
import { Link } from 'react-router-dom';
function SoundBarrier() {
    return (

        <>
            <Helmet>
                <title>Sound Barrier Acoustic Panels | Noise Control & Soundproof Solutions</title>
                <meta name="description" content="High-performance exterior acoustic blanket that combines sound blocking and absorption for effective outdoor noise control." />
                <meta name="robots" content="index, follow" />
                <meta name="geo.placename" content="India" />
                <meta http-equiv="content-language" content="in" />
                <meta name="geo.region" content="india" />
                <meta property="og:title" content="Noise Control & Soundproof Solutions" />
                <meta property="og:description" content="Heavy-duty exterior acoustic blanket engineered to block noise and absorb sound in demanding outdoor environments." />
                <meta property="og:image" content="https://www.acousticalsurfaces.in/images/inner/soundbmain.webp" />
                <meta property="og:locale" content="en-in" />
                <link rel="alternate" href="https://www.acousticalsurfaces.ae/sound-barrier" hreflang="en-ae" />
                <link rel="alternate" href="https://www.acousticalsurfaces.in/sound-barrier" hreflang="en-in" />
                <link rel="canonical" href="https://www.acousticalsurfaces.in/sound-barrier" />
            </Helmet>
            <Header />
            <section className="content" id="soundb">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-3 sidemenu">
                            <Sidebar />
                        </div>
                        <div className="col-sm-9 product-page nopaddding">
                            <div className="container thanks">
                                <div className="megamenu">
                                    <Megamenu />
                                </div>
                                <h1>Exterior Grade Quilted Barrier and Absorber Curtain</h1>
                                <div className="row">
                                    <div className="col-lg-6 col-sm-12">
                                        <img className="example-image" src={soundbmain} alt="soundbmain" />
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                        <p style={{ marginTop: "20px" }}>The BBC-EXT-R-2 Exterior Sound Barrier / Absorber Curtain is a heavy-duty outdoor acoustic solution engineered to both block noise and absorb sound in challenging exterior conditions. This dual-performance curtain integrates a high-density <Link to="https://www.soundbarrier.in" target="_blank" style={{ color: "gray", textDecoration: "underline" }}>noise barrier</Link> with a quilted fiberglass absorptive layer, providing excellent sound transmission reduction while effectively controlling echo and reverberation.</p>
                                        <p>Built for long-term outdoor use, the curtain features a UV-resistant vinyl-coated polyester outer layer quilted over a nominal 2″ thick fiberglass absorber. The absorptive section is bonded to a scrim-reinforced vinyl barrier, delivering strong acoustic insulation in a single durable system. Optional configurations are available with a 1″ fiberglass absorber or an upgraded 2 lb/ft² vinyl barrier, allowing performance to be customised based on project needs.</p>
                                    </div>

                                    <div className="col-sm-12 features mt-3">
                                        <h1>Key Specifications:</h1>
                                        <div className="line"></div>
                                        <div className="row pad">
                                            <div className="col-sm-12">
                                                <ul>
                                                    <li>STC: 33 (standard 1 lb. vinyl barrier)</li>
                                                    <li>NRC: 0.75 (standard 2”) nominally thick fiberglass facing.</li>
                                                    <li>Weight: 1.45 lb/ft²</li>
                                                    <li>Nominal Thickness: 2″</li>
                                                    <li>Temperature Range: -20°F to +180°F</li>
                                                    <li>Standard Width: 54″; custom lengths up to 25′ – most panels are custom made to height as needed.</li>
                                                    <li>Installation: (standard) Grommets top, middle and bottom edges</li>
                                                    <li>Panel connections: Vertical U.V. stable overlapping hook-and-loop stitched to mating vertical edges</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 features mt-3">
                                        <h1>Features:</h1>
                                        <div className="line"></div>
                                        <div className="row pad">
                                            <div className="col-sm-12">
                                                <ul>
                                                    <li>Weather-resistant and UV-stable for exterior use</li>
                                                    <li>Dual-function acoustical performance: barrier + absorber</li>
                                                    <li>Heavy-duty construction for long-term durability</li>
                                                    <li>Grommets and Velcro seams for fast, secure installation</li>
                                                    <li>Custom-fabricated to meet specific project requirements</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 features mt-3">
                                        <h1>Applications:</h1>
                                        <div className="line"></div>
                                        <div className="row pad">
                                            <div className="col-sm-12">
                                                <ul>
                                                    <li>Ideal for outdoor or high-abuse environments where both </li>
                                                    <li>sound absorption and blocking are critical</li>
                                                    <li>Construction site noise barriers</li>
                                                    <li>Pickleball court noise barriers</li>
                                                    <li>HVAC enclosures</li>
                                                    <li>Industrial equipment wraps</li>
                                                    <li>Temporary or permanent outdoor sound walls</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="line"></div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4>Product Specs</h4>
                                        <table className="table table-bordered" style={{ background: "#f5f5f5" }}>
                                            <tbody>
                                                <tr>
                                                    <th>Applications</th>
                                                    <td>Pickleball court panels, Equipment enclosures or fences, Machinery enclosures, HVAC, Air conditioning and air handler fences, Construction Sites, Gun Ranges, Restaurant equipment barrier walls, Pool Equipment enclosures, Generator enclosure panels, Kennel sound barriers, Dumpster noise reduction and many more.</td>
                                                </tr>
                                                <tr>
                                                    <th>Material Composition</th>
                                                    <td>Encapsulated/Quilted fiberglass absorber backed with a dense, heavy vinyl noise barrier. Brass Grommets (standard) and UV stable hook and loop fasteners added as needed. Fully UV and exterior rated components used.</td>
                                                </tr>
                                                <tr>
                                                    <th>Absorptive Facing Thickness</th>
                                                    <td>Nominally 2" fiberglass facing (compressed when quilted). Also available with a nominally 1" fiberglass absorber.</td>
                                                </tr>
                                                <tr>
                                                    <th>Barrier Backer Thickness</th>
                                                    <td>1/8" thick (1 lb. per square foot) rip-stop scrim reinforced vinyl noise barrier. Also available: 1/4" (2 lb. per square foot) rip-stop scrim reinforced vinyl noise barrier.</td>
                                                </tr>
                                                <tr>
                                                    <th>Size</th>
                                                    <td>Maximum individual panel width: 54" edge-to-edge. Height: Made to suit Maximum single panel (roll): 54" x 20'</td>
                                                </tr>
                                                <tr>
                                                    <th>Color</th>
                                                    <td>Quilted Facing: Gray (standard), Black, Tan, White & Barrier Backer: Gray (standard), Black, Tan</td>
                                                </tr>
                                                <tr>
                                                    <th>ColorsInstallation Method</th>
                                                    <td>Screws and Washers, Wire ties, Plastic wratchet fasteners, wire, etc.</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <h4>Color Options </h4>
                                        <table className="table table-bordered" style={{ background: "#f5f5f5" }}>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <img className='img-fluid' src={soundb2} alt="proimg" />
                                                    </td>
                                                    <td>
                                                        <img className='img-fluid' src={soundb3} alt="proimg" />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4>Material Performance:</h4>
                                        <table className="table table-bordered" style={{ background: "#f5f5f5" }}>
                                            <tbody>
                                                <tr>
                                                    <th>Fire Performance</th>
                                                    <td>Exterior grade panels are not class A/1 fire rated. If a similar fire rated product is needed the interior-rated version of these panels BBC-13 would be an option.</td>
                                                </tr>
                                                <tr>
                                                    <th>Light Reflectance</th>
                                                    <td>'-20 Fahrenheit to +180 Fahrenheit</td>
                                                </tr>
                                                <tr>
                                                    <th>Weight</th>
                                                    <td>1.5 lbs. per square foot</td>
                                                </tr>
                                                <tr>
                                                    <th>Minimum Lifespan</th>
                                                    <td>7+ years</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <br />

                                <h4>Related Products</h4>
                                <div className="row">
                                    <div className="col-sm">
                                        <img className="example-image img-fluid" src={soundb4} alt="soundb4" />
                                        <p style={{ textAlign: "center" }}><b>EXT-QFA</b></p>
                                    </div>
                                    <div className="col-sm">
                                        <img className="example-image img-fluid" src={soundb5} alt="soundb5" />
                                        <p style={{ textAlign: "center" }}><b>BBC-13X-2"</b></p>
                                    </div>
                                    <div className="col-sm">
                                        <img className="example-image img-fluid" src={soundb6} alt="soundb6" />
                                        <p style={{ textAlign: "center" }}><b>Sound Silencer</b></p>
                                    </div>
                                </div>
                            </div>
                            <div className="row resources">
                                <div className="col-xl-12 col-lg-12 col-sm-12">
                                    <h2>Additional Resources</h2>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-sm-12">
                                    <h6 className='add-title' style={{ textAlign: "center" }}>Creating Better-Sounding Rooms</h6>
                                    <img className="hvr-grow" src={SoundRooms} alt="Create Better Sounding Rooms" target="_blank" rel="noopener noreferrer" />
                                    <div className="butn">
                                        <a href="https://api.whatsapp.com/send?phone=918277331000&text=Hi" target="_blank" rel="noopener noreferrer">Download eBook</a>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-sm-12">
                                    <h6 style={{ textAlign: "center" }}>Solutions to Common Noise Problems</h6>
                                    <img className="hvr-grow" src={NoiseProb} alt="Common Noise Problems" target="_blank" rel="noopener noreferrer" />
                                    <div className="butn">
                                        <a href="https://api.whatsapp.com/send?phone=918277331000&text=Hi" target="_blank" rel="noopener noreferrer">Download eBook</a>
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-4 col-sm-12">
                                    <h6 style={{ textAlign: "center" }}><br />CAD, CSI, & Revit Library</h6>
                                    <img className="hvr-grow" src={CADCSI} alt="CAD Library" target="_blank" rel="noopener noreferrer" />
                                    <div className="butn">
                                        <a href="https://api.whatsapp.com/send?phone=918277331000&text=Hi" target="_blank" rel="noopener noreferrer">Access Product Cad Files</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className='mobsidebar'>
                        <div className="col-sm-12">
                            <div className="container">
                                <div className="row">
                                    <Mobsidebar />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ScrollToTopButton />
            </section>
            <Footer />
        </>
    );
}
export default SoundBarrier; 